import React from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App/App';
import { AuthContextProvider } from './contexts/authContext';
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import reportWebVitals from './reportWebVitals';
import './styles/styles.scss';

// Token vindo do ay-advogados após login: salva e remove do hash
const hash = typeof window !== 'undefined' ? window.location.hash : '';
const tokenMatch = hash.match(/#token=(.+)/);
if (tokenMatch && tokenMatch[1]) {
	try {
		const token = decodeURIComponent(tokenMatch[1].replace(/^"(.*)"$/, '$1'));
		localStorage.setItem('ay_token', token);
		window.history.replaceState(null, '', window.location.pathname + window.location.search);
	} catch {
		// Token inválido no hash; ignora
	}
}

const children = (
	<AuthContextProvider>
		<ThemeContextProvider>
			<Router>
				<React.StrictMode>
					<App />
				</React.StrictMode>
			</Router>
		</ThemeContextProvider>
	</AuthContextProvider>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18
reportWebVitals();
